import IconButton from "components/Button/IconButton";
import { dataEmpty, generateObjectDummyId } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import NumberTextField from "components/LabelInput/NumberTextField";
import TableTitleWithButton from "components/TableTitleWithButton/TableTitleWithButton";
import { globalAlertOn } from "modules/actions/Alert";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";

const PtClassCard = forwardRef((props, ref) => {
  const { workInfoStore /*, positionDetail, setPositionDetail*/ } = props;
  const [itemInfoList, setItemInfoList] = useState(workInfoStore.pt_fee);
  const [, updateState] = useState(); // 강제 렌더링용
  const forceUpdate = useCallback(() => updateState({}), []);
  const storesDispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    getItemList: () => {
      return itemInfoList;
    },
  }));

  useEffect(() => {
    setItemInfoList(workInfoStore.pt_fee);
  }, [workInfoStore.pt_fee]);

  const btnItemPush = () => {
    // const methodId = uuidv4();
    const baseItemInfo = {
      id: generateObjectDummyId(),
      idx: 0,
      from_section:
        workInfoStore.pt_fee.length === 0
          ? 0
          : workInfoStore.pt_fee[workInfoStore.pt_fee.length - 1].to_section + 1,
      to_section:
        workInfoStore.pt_fee.length === 0
          ? 1
          : workInfoStore.pt_fee[workInfoStore.pt_fee.length - 1].to_section + 2,
      rate: 0.0,
    };
    // console.log(itemInfoList);
    if (itemInfoList.length === 0) {
      setItemInfoList([baseItemInfo]);
    } else {
      setItemInfoList([...itemInfoList, baseItemInfo]);
    }

    workInfoStore.pt_fee.push(baseItemInfo);
    // setPositionDetail({
    //   ...positionDetail,
    //   pt_fee: workInfoStore.pt_fee,
    // });
  };

  const btnItemPop = (targetFromSection) => {
    var array = [...itemInfoList]; // make a separate copy of the array
    const index = array.map((item) => item.from_section).indexOf(targetFromSection);

    if (index !== -1) {
      array.splice(index, 1);

      const lastIdx = array.length - 1;
      for (let i = 0; i < lastIdx; i++) {
        if (i !== lastIdx) {
          const curItem = array[i];
          const nextItem = array[i + 1];

          nextItem.from_section = curItem.to_section + 1;
          if (nextItem.to_section < nextItem.from_section) {
            nextItem.to_section = nextItem.from_section + 1;
          }
        }
      }

      workInfoStore.pt_fee = array;
      setItemInfoList(array);
    }
  };

  const onChangeToSection = (idx, val) => {
    if (val <= workInfoStore.pt_fee[idx].from_section) {
      document.getElementById("pt_fee" + idx).focus();
      storesDispatch(
        globalAlertOn({
          show: true,
          titleText: "알림",
          bodyText: (
            <>
              <Label labelText="종료금액은 시작금액보다 커야 합니다." />
            </>
          ),
          // width: "50rem",
          onBtnOk: () => {},
        }),
      );
    } else {
      const lastIdx = workInfoStore.pt_fee.length - 1;
      for (let i = idx; i < lastIdx; i++) {
        if (i !== lastIdx) {
          const curItem = workInfoStore.pt_fee[i];
          const nextItem = workInfoStore.pt_fee[i + 1];

          nextItem.from_section = curItem.to_section + 1;
          if (nextItem.to_section < nextItem.from_section) {
            nextItem.to_section = nextItem.from_section + 1;
          }
        }
      }
    }

    setItemInfoList(workInfoStore.pt_fee);
    forceUpdate();
  };

  const itemList = new itemInfoTable(btnItemPop, onChangeToSection);

  return (
    <div>
      <TableTitleWithButton
        titleLabel={"PT 수업료"}
        buttonText={"추가"}
        onClickEvent={btnItemPush}
      />

      <CustomTable
        columns_head={itemList.columns_head}
        table_title={itemList.table_title}
        rest_call={itemList.get_data_from_rest}
        row_render={itemList.create_table}
        rest_data={itemInfoList}
      />
    </div>
  );
});
export default PtClassCard;

class itemInfoTable {
  table_title = "pt_fee";

  btnMethodPop = null;
  onChangeToSection = null;

  constructor(btnMethodPop, onChangeToSection) {
    this.btnMethodPop = btnMethodPop;
    this.onChangeToSection = onChangeToSection;
  }

  create_table = (data, idx) => {
    return (
      <CustomRow key={idx} style={{ width: "100%" }}>
        <CustomTableContents width="35%">
          <div style={{ display: "flex" }}>
            <NumberTextField
              isNumber
              endAdornment={"원"}
              labelMarginRight="0rem"
              textMarginRight="0.25rem"
              defaultValue={data.from_section || "0"}
              onChangeCallback={(e) => {
                data.from_section = e;
              }}
              disabled
            />
          </div>
        </CustomTableContents>

        <CustomTableContents width="35%">
          <div style={{ display: "flex" }}>
            <NumberTextField
              isNumber
              endAdornment={"원"}
              id={this.table_title + idx}
              labelMarginRight="0rem"
              textMarginRight="0.25rem"
              defaultValue={data.to_section}
              onChangeCallback={(e) => {
                data.to_section = e;
              }}
              onBlur={(e) => {
                this.onChangeToSection(idx, e);
              }}
            />
          </div>
        </CustomTableContents>

        <CustomTableContents width="20%">
          <div style={{ display: "flex" }}>
            <NumberTextField
              isNumber
              endAdornment={"%"}
              labelMarginRight="0rem"
              textMarginRight="0.25rem"
              maxValue={100}
              defaultValue={data.rate}
              onChangeCallback={(e) => {
                data.rate = e;
              }}
            />
          </div>
        </CustomTableContents>

        <CustomTableContents width="5%">
          {idx === 0 ? (
            <div style={{ width: "4.5rem" }}></div>
          ) : (
            <IconButton type="delete" onClick={() => this.btnMethodPop(data.from_section)} />
          )}
        </CustomTableContents>
      </CustomRow>
    );
  };
  columns_head = [
    { title: "매출구간 시작금액", field: "select" },
    { title: "매출구간 종료금액", field: "pay_method" },
    { title: "수업요율", field: "pay_method" },
    { title: "삭제", field: "remove" },
  ];
  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      return [];
    }

    return stateData;
  };
}
